module.exports = __webpack_public_path__ + "fonts/Jost-700-Bold.813b3d2.otf";